








































































import {Component, Vue} from "vue-property-decorator";
@Component({
  name: "testing-step-1",
})
export default class TestingStep1 extends Vue{
  private tabs = null

  private SvgQrApk = require('@/assets/images/testing/qr/apk.svg')
  private SvgQrAppStore = require('@/assets/images/testing/qr/appstore.svg')
  private SvgQrGooglePlay = require('@/assets/images/testing/qr/google_play.svg')
}
